(function() {
	if (typeof window.WebBaseAprovLV === 'undefined') {
		window.WebBaseAprovLV = {};
	}
	WebBaseAprovLV.config = {
		projectId: '53721173-39bb-0184-4b45-ca96e975b8d7',
		apiUrl: 'https://deliver.kontent.ai/53721173-39bb-0184-4b45-ca96e975b8d7',
		apiFileDeliveryUrl: 'https://assets-eu-01.kc-usercontent.com/',
		apiHeaders: {},
		defaultLang: 'de',
		langId: {
			'de': '00000000-0000-0000-0000-000000000000',
			'it': 'f7ad7e1a-4206-4b85-926b-b955ea74de14',
			'lld': 'f7ad7e1a-4206-4b85-926b-b955ea74de14',
			'en': '0a99d5b4-20e4-4274-bc73-9ee8427bf965'
		},
		authorities: {
			'de': 'https://wetter.provinz.bz.it/',
			'it': 'https://meteo.provincia.bz.it/',
			'lld': 'https://meteo-ladin.provinzia.bz.it/',
			'en': 'https://weather.province.bz.it/'
		},
		azureStorageUrl: {
			'de': 'https://static-wetter.provinz.bz.it/',
			'it': 'https://static-meteo.provincia.bz.it/',
			'lld': 'https://static-meteo-ladin.provinzia.bz.it/',
			'en': 'https://static-weather.province.bz.it/'
		},
		environment: 'prod',
		noovleSearchApiUrl: 'https://api.integrations.services.siag.it/pub/cocweb/quelix/aprov/api/search?',
		noovleSearchCollection: 'coll_aprov_wetter_',
		templatesPath: '/js/templates/',
		socialIcons: {
			'de': [
				{
					'type': 'facebook',
					'url': 'https://www.facebook.com/Wetter.Suedtirol'
				},
				{
					'type': 'instagram',
					'url': ''
				},
				{
					'type': 'twitter',
					'url': ''
				},
				{
					'type': 'linkedin',
					'url': ''
				},
				{
					'type': 'youtube',
					'url': ''
				},
				{
					'type': 'pinterest',
					'url': ''
				},
				{
					'type': 'issuu',
					'url': ''
				},
				{
					'type': 'soundcloud',
					'url': ''
				}
			],
			'it': [
				{
					'type': 'facebook',
					'url': 'https://www.facebook.com/Wetter.Suedtirol'
				},
				{
					'type': 'instagram',
					'url': ''
				},
				{
					'type': 'twitter',
					'url': ''
				},
				{
					'type': 'linkedin',
					'url': ''
				},
				{
					'type': 'youtube',
					'url': ''
				},
				{
					'type': 'pinterest',
					'url': ''
				},
				{
					'type': 'issuu',
					'url': ''
				},
				{
					'type': 'soundcloud',
					'url': ''
				}
			],
			'lld': [
				{
					'type': 'facebook',
					'url': 'https://www.facebook.com/Wetter.Suedtirol'
				},
				{
					'type': 'instagram',
					'url': ''
				},
				{
					'type': 'twitter',
					'url': ''
				},
				{
					'type': 'linkedin',
					'url': ''
				},
				{
					'type': 'youtube',
					'url': ''
				},
				{
					'type': 'pinterest',
					'url': ''
				},
				{
					'type': 'issuu',
					'url': ''
				},
				{
					'type': 'soundcloud',
					'url': ''
				}
			],
			'en': [
				{
					'type': 'facebook',
					'url': 'https://www.facebook.com/Wetter.Suedtirol'
				},
				{
					'type': 'instagram',
					'url': ''
				},
				{
					'type': 'twitter',
					'url': ''
				},
				{
					'type': 'linkedin',
					'url': ''
				},
				{
					'type': 'youtube',
					'url': ''
				},
				{
					'type': 'pinterest',
					'url': ''
				},
				{
					'type': 'issuu',
					'url': ''
				},
				{
					'type': 'soundcloud',
					'url': ''
				}
			]
		},
		cookieiub: {
			siteId: 2957622,
			iub: {
				de: {
					'lang': 'de',
					'cookiePolicyId': 57414464,
					'cookiePolicyUrl': '/de/cookie',
					'privacyPolicyUrl': '/de/privacy'
				},
				it: {
					'lang': 'it',
					'cookiePolicyId': 89117220,
					'cookiePolicyUrl': '/it/cookie',
					'privacyPolicyUrl': '/it/privacy'
				},
				lld: {
					'lang': 'lld',
					'cookiePolicyId': 57414464,
					'cookiePolicyUrl': '/lld/cookie',
					'privacyPolicyUrl': '/lld/privacy'
				},
				en: {
					'lang': 'de',
					'cookiePolicyId': 89117220,
					'cookiePolicyUrl': '/en/cookie',
					'privacyPolicyUrl': '/en/privacy'
				}
			}
		}
	};
})();
